import React from "react";
import { Link, useRoute, useParams, useModel } from "@bcm-dev/bcms-vite";
import { SVGAsset } from "res";
import { UIPrimaryButton } from "components/ui/UIButton";
import { Card } from "model";

import "./styles.css";

/**
 * @function CardOnItsWayView
 * @return {React.Component}
 * @exported true
 * @description The main component for CardOnItsWayView
 */
export default function CardOnItsWayView(props) {
  const navigate = useRoute();
  const { branding } = useModel();

  const defaultCard = branding.options.include_debit_chw23 !== "false" ? "0" : "1";
  const cardID = useParams().cardID ?? defaultCard;
  const card = Card.initByID(cardID);

  const doneBtn = evt => navigate(`/home/recenttransactions/${ cardID }`);

  return (
    <div className="card-on-its-way-view text-center">
      <div className="framed-icon-container">
        <SVGAsset id="OutlineCardIcon" className="card-icon" />
        <SVGAsset id="CheckmarkCircleIcon" className="CheckmarkCircleIcon" />
      </div>
      <p><b>Your new card ending in { card.maskedNumber } is on its way</b></p>
      <p>While you wait for your card to arrive, you can make online purchases. View your card credentials through <Link to={ `/home/securitytoken/receivetoken/${ cardID }/viewdigitalcard` }>View Digital Card</Link>.</p>
      <p>Activate your new card when you receive it in the mail.</p>
      <p>Remember to update your card on file with your merchants and service providers.</p>
      <UIPrimaryButton text="Done" onClick={ doneBtn } />
    </div>
  )

}